import React from "react";

import BoiReactMarkdown from "../../boi-markdown/boi-markdown";
import List from "../../list/list";
import LoadingIcon from "../../loading-icon/loading-icon";
import { Box, PageActionsContainer } from "../../theme/containers";
import { Paragraph, PcaHeading, PcaSubHeading } from "../../theme/typography";

type DocumentStatusProps = {
    icon: JSX.Element,
    headingText: string,
    subheadingText?: string,
    paragraphText?: string,
    button?: JSX.Element,
    listItems?: JSX.Element[],
    loading?: boolean
};

const DocumentStatus = ({
    icon,
    headingText,
    subheadingText,
    paragraphText,
    button,
    listItems,
    loading
}: DocumentStatusProps) => {
    return (
        <div className="u-text-centre">
            <Box className="u-mx-auto">{icon}</Box>
            <PcaHeading className="u-my-6">{headingText}</PcaHeading>
            {subheadingText && (
                <PcaSubHeading>
                    <BoiReactMarkdown
                        disallowedElements={["p"]}
                        unwrapDisallowed={true}
                    >{subheadingText}</BoiReactMarkdown>
                </PcaSubHeading>
            )}
            {paragraphText && (
                <Paragraph>{paragraphText}</Paragraph>
            )}
            {loading && (
                // @ts-ignore
                <LoadingIcon size="medium" />
            )}
            {listItems && (
                <List
                    type="checked"
                    items={listItems}
                    className="u-text-left"
                />
            )}
            {button && (
                <PageActionsContainer className="block" id="actions">
                    {button}
                </PageActionsContainer>
            )}
        </div>
    )
};

export default DocumentStatus;
